module.exports = __webpack_public_path__ + "static/media/my-rating.8792e130.svg";